(function (upp) {
    'use strict';

    //PLUGIN FOR MODULES:
    // * ESHOP
    // * CART
    // * PROMOTIONS

    upp.directive('productsPrices', ['$filter', '$sce',
        function ($filter, $sce) {
            return {
                restrict: 'E',
                scope: {                   
                    price: '=',
                    priceFinal: '=',
                    currency: '='
                },
                template: '' +
                    '<div class="product-prices" data-ng-if="price && price > 0">' +
                    '   <span data-ng-class="{\'price\': true, \'price-old\': checkPromotion(), \'price-actual\': !checkPromotion()}">' +
                    '       {{ price | numberDecimalNoZero:2 }}&nbsp;<span data-ng-bind-html="currency"></span>' +
                    '   </span>' +
                    '   <span class="price promotion price-new" data-ng-if="checkPromotion()">' +
                    '       {{ priceFinal | numberDecimalNoZero:2 }}&nbsp;<span data-ng-bind-html="currency"></span>' +
                    '   </span>' +
                    '</div>',
                replace: true,
                link: function ($scope) {
                    $scope.checkPromotion = function() {
                        return $scope.price != $scope.priceFinal;
                    };
                }
            }
        }]);

})(upp);




// WEBPACK FOOTER //
// ./src/app/plugins/products/directives/products-prices-directive.js